import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);

export const WithinTerritory = () =>
    t('reportUsage.replen.selectShipToAddress.withinTerritory');
export const OutsideTerritory = () =>
    t('reportUsage.replen.selectShipToAddress.outsideTerritory');
export const AllDistricts = 'ALL_Districts';
export const AllTerritories = 'All_Territories';
